import { inject, injectable } from 'inversify';
import CreditCardsRepository from 'src/features/creditCards/data/CreditCardsRepository';
import { DeleteCardParams } from 'src/features/creditCards/domain/CreditCardsRepositoryInterface.types';

@injectable()
class DeleteCardUseCase {
  @inject(CreditCardsRepository)
  private readonly creditCardsRepository!: CreditCardsRepository;

  public async execute(params: DeleteCardParams) {
    return this.creditCardsRepository.deleteCard(params);
  }
}

export default DeleteCardUseCase;
